<template>
  <el-icon class="menu-icon" v-if="menu">
    <Folder v-if="menu.isFolder" />
    <Document v-else />
  </el-icon>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'

const { Folder, Document } = ElementPlusIcons

const props = withDefaults(
  defineProps<{
    menu?: any
  }>(),
  {
    menu: false
  }
)
</script>

<style lang="scss" scoped></style>
